import {useSelector} from 'react-redux'
import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
} from 'react-router-dom'
import authRoute from '@router/auth'
import AuthLayout from '@pages/Authentication/AuthenLayout'
import {EmptyLayout} from '@pages/NonAuthentication/EmptyLayout'
import {ErrorPageStrategy} from '@pages/NonAuthentication/ErrorBoundary'
import nonAuthRoute from '@router/nonAuth'
import InAppBrowser from '@components/InAppBrowser'
import {getUserId, isFacebookInAppBrowser} from '@utils'
import {LOCAL_STORAGE} from '@utils/Const'
import {useEffect, useState} from 'react'

const Layout = () => {
  const {isShowInAppBrowser} = useSelector((state: any) => state.shared)
  const userId = getUserId()
  const [currentUrl, setCurrentUrl] = useState(window.location.href)

  // Xử lý gắn userId vào url khi được chuyển đổi trong InAppBrowser facebook
  useEffect(() => {
    console.log('isFacebookInAppBrowser', isFacebookInAppBrowser())
    if (!isFacebookInAppBrowser()) return
    const handleUrlChange = () => {
      setCurrentUrl(window.location.href)
    }

    window.addEventListener('popstate', handleUrlChange)
    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState

    window.history.pushState = function (
      ...args: Parameters<typeof originalPushState>
    ) {
      originalPushState.apply(this, args)
      handleUrlChange()
    }

    window.history.replaceState = function (
      ...args: Parameters<typeof originalReplaceState>
    ) {
      originalReplaceState.apply(this, args)
      handleUrlChange()
    }

    if (userId) {
      const newUrl = new URL(window.location.href)
      newUrl.searchParams.set(LOCAL_STORAGE.USER_ID, userId)
      window.history.replaceState({}, '', newUrl)
    }

    return () => {
      window.removeEventListener('popstate', handleUrlChange)
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
    }
  }, [userId, currentUrl])

  const router = createBrowserRouter([
    {
      element: (
        <>
          <ScrollRestoration getKey={location => location.pathname} />
          <AuthLayout />
        </>
      ),
      errorElement: <ErrorPageStrategy />,
      children: authRoute,
    },
    {
      element: <EmptyLayout />,
      children: nonAuthRoute,
    },
  ])

  return (
    <>
      {isShowInAppBrowser ? (
        <InAppBrowser />
      ) : (
        <RouterProvider router={router} />
      )}
    </>
  )
}
export default Layout
